<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; padding-bottom: 2%; min-height: 100vh;">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-4 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไขสิทธิ์
        </span>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-4 mr-2 action-top-btn">
        <v-btn
          outlined
          class="button-color-outline ml-2 mr-2"
          @click="promtDialog = true"
        >
          <span class="">
            ยกเลิก
          </span>
        </v-btn>
        <v-btn
          class="button-color ml-2 white--text"
          elevation="0"
          style="margin-right: 0px;"
          :disabled="!allowSave"
          @click="dialogConfirmSubmitData = true"
        >
          <span class="ra-text-in-button">
            บันทึกข้อมูล
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <!-- {{dataFromAPI}} -->
    <FullLoading :loading="loading" v-if="loading" style="margin-top: 30vh;"></FullLoading>
    <v-card height="auto" min-height="82vh" class="pa-6" v-else>
      <v-row style="margin-top: -16px;">
        <v-col>
        <span class="blue--text text--darken-2 font-weight-bold">รายละเอียด</span>
        <v-divider class="mt-1"></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <span class="head-search-text">เครือบริษัท</span>
          <v-autocomplete
            v-model="selectedGroupCompany"
            :items="itemGroupCompanys"
            item-text="groupCompanyNameTh"
            item-value="_id"
            outlined
            dense
            class="mt-2"
            :append-icon="selectedGroupCompany? '' : '$dropdown'"
            :placeholder="selectedGroupCompany? '' : 'เลือกบริษัท'"
            no-data-text="ไม่พบข้อมูล"
            :disabled="!!forwardParams"
            @change="getSelector(), selectedCompany = []"
          >
            <template v-slot:selection="data">
              <v-chip
                class="mt-1 mb-1"
                color="#EFF4FD"
                v-bind="data.attrs"
                :input-value="data.selected"
                :close="forwardParams==''"
                close-icon="mdi-close"
                label
                filter
                small
                @click:close="selectedGroupCompany = ''"
                style="color: #999999;"
              >
                <span style="color: #3776E9;">{{ data.item.groupCompanyNameTh }}</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="7">
          <span class="head-search-text">บริษัท</span>
          <v-autocomplete
            v-model="selectedCompany"
            :items="itemCompanys"
            item-text="companyFullName"
            item-value="_id"
            multiple
            outlined
            dense
            class="mt-2"
            placeholder="เลือกบริษัท"
            no-data-text="ไม่พบข้อมูล"
            :disabled="!selectedGroupCompany"
            @change="itemCompanys.length === selectedCompany.length ? selectedCompanyAll = true : selectedCompanyAll = false"
          >
            <template v-slot:selection="data">
              <!-- {{selectedCompany.indexOf(data.item._id)}} -->
              <!-- <div v-show="data.index === 0"> -->
              <v-chip
                class="mt-1 mb-1"
                color="#EFF4FD"
                v-bind="data.attrs"
                :input-value="data.selected"
                :close="true"
                close-icon="mdi-close"
                label
                filter
                small
                @click:close="selectedCompany.splice(selectedCompany.indexOf(data.item._id), 1)"
                style="color: #999999;"
              >
                <span style="color: #3776E9;">{{ data.item.companyFullName }}</span>
              </v-chip>
              <!-- </div> -->
            </template>
            <!-- <template v-slot:append>
              <v-chip
                v-if="selectedCompany.length > 1"
                class="mt-0 mb-0"
                color="#EFF4FD"
                label
                filter
                small
                style="color: #999999;"
              >
                <span style="color: #3776E9;">+ {{ selectedCompany.length - 1 }} บริษัท</span>
              </v-chip>
            </template> -->
            <template v-slot:prepend-item="">
              <v-hover
                v-slot="{ hover }"
                v-show="itemCompanys.length > 0"
                style="cursor: pointer; "
              >
              <v-list-item
                @click="clickSelectedCompanyAll()"
               :style="`${selectedCompanyAll? 'background-color: #e9effc' : hover? 'background-color: #f6f6f7':''}`"
              >
              <v-list-item-action>
                <div>
                  <v-checkbox
                    style="margin-top: 5px; margin-bottom: -10px;"
                    color="primary"
                    v-model="selectedCompanyAll"
                  ></v-checkbox>
                </div>
              </v-list-item-action>
                <v-list-item-title
                  :style="`${selectedCompanyAll? 'color: #4775e1' : 'color: #373636'}`"
                  v-text="'ทั้งหมด'"
                ></v-list-item-title>
              </v-list-item>
              </v-hover>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <span class="head-search-text">Activated</span>
          <!-- <v-text-field
            v-model="keywordSearch"
            item-text="groupCompanyNameFull"
            item-value="groupCompanyId"
            multiple
            outlined
            dense
            clearable
            class="mt-2"
            placeholder="Search"
            no-data-text="ไม่พบข้อมูล"
            @change="getData()"
            @click:clear="keywordSearch='', getData()"
          >
            <template v-slot:append>
              <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="getData()">
            </template>
          </v-text-field> -->
          <v-autocomplete
            v-model="selectStatus"
            :items="itemsStatus"
            outlined
            dense
            class="mt-2"
            placeholder="เลือกสถานะ"
            no-data-text="ไม่พบข้อมูล"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card
            style="margin-top: -14px; border: 1px solid #E0E0E0;"
            outlined
            elevation="0"
          >
            <v-card-title class="pl-4 pr-4" style="height: 36px; padding: 0; background: #EFF4FD;">
              <span class="head-search-text black--text">สิทธิ์หลัก</span><span class="head-search-text red--text">*</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" style="" class="pb-0">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ชื่อสิทธิ์หลัก</span><br>
                  <v-text-field
                    v-model="rightName"
                    outlined
                    dense
                    class="mt-1"
                    placeholder="ระบุชื่อสิทธิ์หลัก"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0">
                  <span class="grey--text text-darken-4 mt-1 mb-1">หมายเหตุ</span><br>
                  <v-textarea
                    v-model="note"
                    outlined
                    dense
                    rows="2"
                    class="mt-1"
                    placeholder="กรอกรายละเอียด"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12">
          <v-card
            style="margin-top: -14px; border: 1px solid #E0E0E0; min-height: 150px;"
            outlined
            elevation="0"
          >
            <v-card-title class="pl-4 pr-4" style="height: 36px; padding: 0; background: #EFF4FD;">
              <span class="head-search-text black--text">สิทธิ์ย่อย</span><span class="head-search-text red--text">*</span>
              <v-spacer/>
              <v-btn
                elevation="0"
                class=""
                outlined
                style="border: 1px solid grey; background-color: white;"
                right
                small
                width="90"
                @click="addSub()"
              >
                <v-icon style="color: #3776E9;" left size="14px">
                  mdi-plus
                </v-icon>
                <span class="" style="color: #3776E9;">เพิ่มสิทธิ์</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row
                v-for="(itemSub, i) in rightSubs"
                :key="itemSub._id"
                class="pl-6 pr-12"
              >
                <span style="position: absolute; left: 16px; margin-top: 9px;">{{i+1}}.</span>
                <v-col cols="6" style="" class="pt-2 pb-0">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ชื่อสิทธิ์ย่อย</span><br>
                  <v-text-field
                    v-model="itemSub.name"
                    outlined
                    dense
                    class="mt-1"
                    placeholder="ระบุชื่อสิทธิ์ย่อย"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pt-2 pb-0">
                  <span class="grey--text text-darken-4 mt-1 mb-1">หมายเหตุ</span><br>
                  <v-textarea
                    v-model="itemSub.note"
                    outlined
                    dense
                    rows="1"
                    class="mt-1"
                    placeholder="กรอกรายละเอียด"
                  >
                  </v-textarea>
                </v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      color="#FFB300"
                      dark
                      icon
                      absolute
                      right
                      height="40"
                      width="40"
                      class="ra-border-button ml-6 mr-0"
                      style="right: 15px; margin-top: 35px;"
                      @click="(itemSub.name || itemSub.note) ? (dialogConfirmRemove = true, onFocusSubItem = itemSub) : (removeSub(itemSub))"
                    >
                    <v-icon color="error" small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span class="label-table-action">ลบข้อมูล</span>
                </v-tooltip>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogConfirmRemove" max-width="344px" persistent>
      <v-card >
        <v-card-title class="ra-head-text-bold justify-center pa-5">
          ต้องการลบข้อมูลสิทธิ์ย่อยใช่ไหม
        </v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลสิทธิ์ย่อย</span>
        </v-card-text>
        <v-card-actions class="justify-center mt-0 pb-5">
            <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="100"
              @click="dialogConfirmRemove = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="100"
              @click="removeSub(onFocusSubItem), dialogConfirmRemove = false"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSubmitData" max-width="344px" persistent>
      <v-card >
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล</span>
        </v-card-text>
        <v-card-actions class="justify-center mt-0 pb-5">
           <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="90"
              @click="dialogConfirmSubmitData = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="90"
              @click="submitData()"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="promtDialog"
      persistent
      max-width="350"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            ต้องการออกจากหน้านี้ใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            ข้อมูลของคุณยังไม่ถูกบันทึก <br> คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            color="primary"
            class="head-search-button ml-10 mt-2 mb-2 white--text text--lighten-4"
            width="275"
            @click="goBack()"
          >
          ตกลง ฉันจะออกจากหน้านี้
          </v-btn>
          <v-btn
            color="primary"
            class="ml-10 mt-2 mb-2 "
            width="275"
            outlined
            @click="promtDialog = false"
          >
          ไม่ ฉันจะอยู่ต่อหน้านี้
          </v-btn>
        </div>
        <v-card-actions class="">
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { FullLoading } from '@/components/index'
const axios = require('axios')

export default {
  components: {
    FullLoading
  },
  name: 'createRight',
  data () {
    return {
      loading: false,
      dialogShow: false,
      promtDialog: false,
      dialogConfirmRemove: false,
      dialogConfirmSubmitData: false,
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      forwardParams: '',
      forwardGroupID: '',
      forwardCompanyID: '',
      forwardID: '',
      backParam: '',
      itemGroupCompanys: [],
      selectedGroupCompany: '',
      itemCompanys: [],
      selectedCompany: [],
      itemsStatus: ['Draft', 'Activated', 'Deactivated'],
      selectStatus: '',
      rightName: '',
      note: '',
      rightSubs: [],
      onFocusSubItem: {},
      dataOrigin: {},
      dataFromAPI: {},
      selectedCompanyAll: false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  computed: {
    checkCompany () { return !!this.selectGroupCompany.length },
    allowSave () {
      var result = this.rightName && this.note && this.selectedGroupCompany && this.selectedCompany.length && this.selectStatus && this.alreadyRightSubs
      return result
    },
    alreadyRightSubs () {
      var typed = this.rightSubs.filter(e => { return e.name && e.note }).length
      var blank = this.rightSubs.filter(e => { return !e.name && !e.note }).length
      var pass = typed + blank
      return pass === this.rightSubs.length
    }
  },
  watch: {
  },
  async created () {
    this.loading = true
    this.forwardParams = this.$route.params.id
    if (this.forwardParams) {
      await this.decryptID(this.forwardParams)
      this.selectedGroupCompany = this.forwardGroupID
      this.selectedCompany = [this.forwardCompanyID]
    }
    await this.getSelector()
    // await this.addSub()
    await this.getData()
  },
  methods: {
    goBack () {
      if (this.forwardParams) this.$router.push('/manageroleapprover/c/' + this.backParam)
      else this.$router.push('/manageroleapprover')
    },
    async decryptID (id) {
      const cleanData = JSON.parse(atob(id))
      this.forwardGroupID = cleanData.groupid
      this.forwardCompanyID = cleanData.companyid
      this.backParam = cleanData.backParam
      this.forwardID = cleanData.id
    },
    async addSub () {
      this.rightSubs.push(
        {
          _id: 'newItem' + Math.random(),
          name: '',
          note: ''
        }
      )
    },
    async removeSub (item) {
      this.rightSubs.splice(this.rightSubs.indexOf(item), 1)
    },
    async getSelector () {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/select`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
            groupCompanyId: this.selectedGroupCompany ? [this.selectedGroupCompany] : []
          }
        })
          .then(response => {
            if (response.data.success === true) {
              this.itemCompanys = response.data.company
              this.itemGroupCompanys = response.data.groupCompany
            } else {
              this.itemCompanys = []
              this.itemGroupCompanys = []
            }
          })
          .catch(function (thrown) {})
      } catch (error) {
      } finally {
      }
    },
    async getData () {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/${this.forwardID}`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then(async response => {
            if (response.data.success === true) {
              this.dataFromAPI = response.data.result
              this.dataOrigin = JSON.parse(JSON.stringify(this.dataFromAPI))
              this.selectedGroupCompany = this.dataFromAPI.groupId
              this.selectedCompany = this.dataFromAPI.company.map(({ _id }) => (_id)) || []
              this.selectStatus = this.dataFromAPI.status.charAt(0).toUpperCase() + this.dataFromAPI.status.slice(1) || ''
              this.rightName = this.dataFromAPI.name
              this.note = this.dataFromAPI.notic
              this.rightSubs = await this.flowSubRight(this.dataFromAPI.subRight)
            } else {
              this.dataFromAPI = {}
              this.dataOrigin = {}
              this.selectedGroupCompany = ''
              this.selectedCompany = []
              this.selectStatus = ''
              this.rightName = ''
              this.note = ''
              this.rightSubs = []
            }
          })
          .catch(function (thrown) {})
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async flowSubRight (data) {
      var result = []
      data.map(e => {
        result.push({
          _id: e._id,
          name: e.name,
          note: e.notic
        })
      })
      return result
    },
    async sufferSubRight () {
      var result = []
      this.rightSubs.map(e => {
        if (e.name && e.note) {
          result.push({
            _id: e._id.includes('newItem0') ? undefined : e._id,
            name: e.name,
            notic: e.note
          })
        }
      })
      return result
    },
    async submitData () {
      var payload = {
        mainId: this.forwardID,
        name: this.rightName,
        groupId: this.selectedGroupCompany,
        companyId: this.selectedCompany,
        notic: this.note,
        status: this.selectStatus.toLowerCase(),
        subRight: await this.sufferSubRight()
      }
      // console.log('submit', payload)
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/edit`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: payload
        })
          .then((response) => {
            if (response.data.success === true) {
              swal('สำเร็จ', 'บันทึกแก้ไขสิทธิ์สำเร็จ', 'success', {
                button: false,
                timer: 1500
              })
              this.goBack()
            } else {
              swal('ผิดพลาด', 'บันทึกแก้ไขไม่สำเร็จ', 'error', {
                button: false,
                timer: 2000
              })
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    clickSelectedCompanyAll () {
      if (this.selectedCompany.length === this.itemCompanys.length) {
        this.selectedCompany = []
        if (this.selectedCompanyAll) this.selectedCompanyAll = false
      } else {
        this.selectedCompany = this.itemCompanys.map(({ _id }) => (_id))
        if (!this.selectedCompanyAll) this.selectedCompanyAll = true
      }
    }
  }
}
</script>
